import React, { useRef, forwardRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';
import { BsPrinter } from 'react-icons/bs';

const PrintModal = forwardRef(({ show, onHide, content, title }, ref) => {
  // ...existing PrintModal code...
});

export default PrintModal;
